import { generateJSON, generateHTML, getSchema } from '@tiptap/core';
import { composerExtensions } from './composerExtensions';
import { templateContent } from './templateContent';

// HTML remains the delivery format for web/mobile. The editor document is a
// second representation of the same content, never a separate story.
export function editorDocument(html, document) {
  return {
    format: 'tiptap',
    version: 1,
    sourceHtml: html,
    document:
      document || generateJSON(templateContent(html), composerExtensions()),
  };
}

export function loadEditorDocument(html, saved) {
  if (
    saved?.format === 'tiptap' &&
    saved.version === 1 &&
    saved.sourceHtml === html
  ) {
    try {
      const extensions = composerExtensions();
      getSchema(extensions).nodeFromJSON(saved.document).check();
      // Persisted JSON can come from older clients. Apply the same HTML safety
      // policy before allowing attributes from it into a node view.
      return generateJSON(
        templateContent(generateHTML(saved.document, extensions)),
        extensions
      );
    } catch (_) {
      /* An old/invalid cache must never hide the canonical content. */
    }
  }
  return editorDocument(html).document;
}
